import { Alert, Box, Card, CardContent, Chip, CircularProgress, Stack, Typography } from '@mui/material'

export type PropostaIaState = {
  texto?: string | null
  modelo?: string | null
  fonte?: string | null
  cached?: boolean
  gerado_em?: string | null
  loading?: boolean
  erro?: string | null
}

/**
 * Cartão de proposta IA na UI — mesma disciplina do Score / Insight:
 * texto Claude em cima da verdade (KPIs/tabelas); humano revê antes de agir.
 */
export function PropostaIaCard({
  title,
  caption,
  state,
  onRetry,
}: {
  title: string
  caption: string
  state: PropostaIaState
  onRetry?: () => void
}) {
  const { texto, modelo, fonte, cached, gerado_em, loading, erro } = state
  return (
    <Card>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }} flexWrap="wrap" useFlexGap>
          <Typography variant="h6" sx={{ mr: 'auto' }}>
            {title}
          </Typography>
          <Chip size="small" label="Proposta da IA" color="primary" variant="outlined" />
          {modelo ? <Chip size="small" label={modelo} variant="outlined" /> : null}
          {fonte === 'llm' ? (
            <Chip size="small" color="primary" label="Claude" variant="outlined" />
          ) : null}
          {cached ? <Chip size="small" label="cache" variant="outlined" /> : null}
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.25 }}>
          {caption}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'grid', placeItems: 'center', py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : null}
        {!loading && erro ? (
          <Alert
            severity="info"
            action={
              onRetry ? (
                <Chip size="small" label="Tentar de novo" onClick={onRetry} clickable variant="outlined" />
              ) : undefined
            }
          >
            {erro}
          </Alert>
        ) : null}
        {!loading && texto ? (
          <>
            {gerado_em ? (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                Gerada em{' '}
                {new Date(gerado_em).toLocaleString('pt-BR', {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
              </Typography>
            ) : null}
            <Typography
              variant="body2"
              sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.55, maxHeight: 420, overflow: 'auto', pr: 0.5 }}
            >
              {texto}
            </Typography>
          </>
        ) : null}
      </CardContent>
    </Card>
  )
}
